


















































import { Component, Vue } from 'vue-property-decorator';
import Stat from '@/components/Stat.vue';
import slug from 'vue-string-filter/libs/slug';
import { categories, scrapers } from '../data';

@Component({
  components: {
    Stat,
  },
})
export default class ScraperChecks extends Vue {
  private scraperKey = '';
  private browserKey = '';
  private readonly categoriesAndLayers: {
    title: string;
    isLayer: boolean;
    isImplemented: boolean;
    slug: string;
  }[] = [];

  get findings() {
    return scrapers[this.scraperKey].browserFindings;
  }

  get browserFindings() {
    return this.findings[this.browserKey];
  }

  get scrapers() {
    return Object.keys(scrapers).map(x => ({
      code: x,
      label: scrapers[x].title,
    }));
  }

  get browsers() {
    return Object.keys(this.findings)
      .map(x => ({
        code: x,
        label: this.titleCase(x),
      }))
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      });
  }

  get scraper() {
    return scrapers[this.scraperKey].title;
  }

  get browser() {
    return this.titleCase(this.browserKey);
  }

  constructor() {
    super();
    for (const [category, entry] of Object.entries(categories)) {
      if (!this.categoriesAndLayers.some(x => x.title === entry.layer.toUpperCase() && x.isLayer)) {
        this.categoriesAndLayers.push({
          title: entry.layer.toUpperCase(),
          isLayer: true,
          isImplemented: true,
          slug: '',
        });
      }

      this.categoriesAndLayers.push({
        title: category,
        isLayer: false,
        isImplemented: entry.implemented,
        slug: slug(category),
      });
    }
  }

  gotoBenchmark(slug: string) {
    this.$router.push({
      name: 'scraperBenchmark',
      params: {
        scraperKey: this.scraperKey,
        browserKey: this.browserKey,
      },
      hash: '#' + slug,
    });
  }

  safeFindings(category: string) {
    return this.browserFindings[category] ?? { checks: 0, flagged: 0, botPct: 0 };
  }

  created() {
    this.scraperKey = Object.keys(scrapers)[0];
    this.browserKey = Object.keys(this.findings)[0];
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  titleCase(str: string) {
    return str
      .split('__')
      .reverse()
      .map(this.capitalizeFirstLetter)
      .join(' on ')
      .replace(/_/g, ' ')
      .split(' ')
      .join(' ')
      .replace('Mac os x', 'Mac OS X')
      .replace(' 0 0', ' ')
      .replace(' 0', ' ')
      .replace(/(\d+)\s(\d+)/g, '$1.$2');
  }
}
